import { render, staticRenderFns } from "./SunExposure.vue?vue&type=template&id=5bd5fc8c&scoped=true&"
import script from "./SunExposure.vue?vue&type=script&lang=ts&"
export * from "./SunExposure.vue?vue&type=script&lang=ts&"
import style0 from "./SunExposure.vue?vue&type=style&index=0&id=5bd5fc8c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd5fc8c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer})
